import { useConfig } from '@salesforce/storefront-next-runtime/config';
import { useAuth } from '@/providers/auth';
import type { AppConfig } from '@/types/config';

/**
 * True when the guest wishlist experience should be hidden/blocked — B2B mode is
 * enabled (`config.features.b2b.enabled`) and the current shopper is not a signed-in
 * registered customer. Registered shoppers keep full wishlist functionality on B2B
 * sites; only the guest (gcid) wishlist experience is disabled.
 *
 * Used by every guest-wishlist entry point (header icon, PLP/tile hearts, PDP heart,
 * cart line-item link) so the gating decision has a single source of truth.
 */
export function useGuestWishlistDisabled(): boolean {
    const config = useConfig<AppConfig>();
    const session = useAuth();
    const isAuthenticated = session?.userType === 'registered' && Boolean(session?.customerId);
    return config.features.b2b.enabled && !isAuthenticated;
}
